<template>
  <div class="page">
    <ClientsSectionTabs action-text="+ Создать корп. клиента" action-permission="add_corpclient" @action="setDialogCreateShow(true)">
      <template v-slot:actions>
        <v-btn v-if="tagsAvailable" outlined color="primary" @click="tagsDialog = true">
          <v-icon left small>mdi-tag-multiple-outline</v-icon> Теги
        </v-btn>
      </template>
    </ClientsSectionTabs>
    <div v-if="!inClientsSection" class="row">
      <div class="col d-flex align-center">
        <h1 class="font-lg">Корпоративные клиенты</h1>
      </div>
      <div class="col-auto d-flex align-center" v-if="$store.getters['auth/isAllowed']('add_corpclient')">
        <v-btn v-if="tagsAvailable" class="mr-2" outlined color="primary" @click="tagsDialog = true">
          <v-icon left small>mdi-tag-multiple-outline</v-icon> Теги
        </v-btn>
        <v-btn color="primary" @click="setDialogCreateShow(true)">
          <v-icon left small>mdi-plus</v-icon>
          <span class="d-none d-sm-inline">Создать корп. клиента</span>
          <span class="d-sm-none">Создать</span>
        </v-btn>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <ClientsTable />
      </div>
    </div>

    <ClientCreateModal />
    <CorpTagsManager v-if="tagsAvailable" v-model="tagsDialog" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClientsSectionTabs from '@/components/clients/ClientsSectionTabs.vue';
import { allowedClientsSectionTabs } from '@/common/constants/clientsSection';
import { COLORS } from '@/common/constants/colors';
import ClientsTable from '@/components/clients/ClientsTable';
import ClientCreateModal from '@/components/clients/ClientCreateModal';
import CorpTagsManager from '@/components/clients/tags/CorpTagsManager.vue';

export default {
  name: 'Clients',
  metaInfo: {
    title: 'Корпоративные клиенты'
  },
  components: {
    ClientsSectionTabs,
    ClientCreateModal,
    ClientsTable,
    CorpTagsManager,
  },
  data: () => ({
    colors: COLORS,
    tagsDialog: false,
    sheet: false,
    remainsOfTests: false,
    usedTotal: true
  }),
  computed: {
    // У админа заголовок и кнопка — в шапке раздела «Клиенты»
    inClientsSection() {
      return allowedClientsSectionTabs(this.$store).length > 0;
    },
    ...mapGetters({
      selected: 'users/clients/selected',
      tagsAvailable: 'users/corpClientTags/available',
    })
  },
  methods: {
    ...mapActions({
      setSelected: 'users/clients/setSelected',
      setDialogCreateShow: 'users/clients/setDialogCreateShow'
    })
  },
  beforeDestroy() {
    this.setSelected(null);
  }
};
</script>
